import { Outlet } from "react-router-dom";

export default function AdminLayout() {
  return (
    <div style={{ minHeight: "100vh", background: "#f5f7fb" }}>
      <Outlet />
    </div>
  );
}
